// Lightweight, device-local preview flags for E2EE conversations.
// The backend only exposes `last_message.e2ee: true` (a boolean) — never the
// message type — so the chat list can't tell an encrypted photo from encrypted
// text. When ChatThread decrypts a conversation's latest message it records ONLY
// a boolean image flag + timestamp here (never any decrypted text/bytes), which
// keeps E2EE-at-rest intact while letting the list show a "photo" hint.
const KEY = "bloq_e2ee_preview";

function loadAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function setE2eePreview(conversationId, { img, at }) {
  if (!conversationId) return;
  const all = loadAll();
  all[conversationId] = { img: !!img, at: at || null };
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* storage full / unavailable — non-fatal */
  }
}

export function getE2eePreview(conversationId) {
  return loadAll()[conversationId] || null;
}

export function clearAllPreviews() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* non-fatal */
  }
}
